import { render, staticRenderFns } from "./FolderDlg.vue?vue&type=template&id=69517048&scoped=true"
import script from "./FolderDlg.vue?vue&type=script&lang=js"
export * from "./FolderDlg.vue?vue&type=script&lang=js"
import style0 from "./FolderDlg.vue?vue&type=style&index=0&id=69517048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69517048",
  null
  
)

export default component.exports